import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_HomeroomSetup } from "./shared/data.service";
import { UserService } from "../../../shared";
import { AdminSetupEditHomeroomComponent } from "./admin-setup-edit-homeroom/admin-setup-edit-homeroom.component";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import * as moment from "moment";

@Component({
	selector: "caass-homeroom-setup",
	templateUrl: "./homeroom-setup.component.html",
	styleUrls: ["./homeroom-setup.component.css"],
})
export class HomeroomSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private HomeroomSetupService: DataService_HomeroomSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////
	SchoolID: any;
	lstSchool: any = [];

	//Main
	SelectedHomeroom: any;
	lstHomeroom: any = [];

	//Filter lists
	lstAcademyDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Homeroom", header: "Homeroom" },
		{ field: "AcademyDesc", header: "Academy" },
		{ field: "Administrator_PersonName", header: "Administrator" },
		{ field: "Advisor_PersonName", header: "Advisor" },
		{ field: "TardyTimeDesc", header: "Tardy Time" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadHomeroom();
			},
			(error) => {}
		);
	}

	loadHomeroom() {
		this.loading = true;

		var result = this.HomeroomSetupService.LoadHomeroom(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				for (var i = 0; i < this.lstHomeroom.length; i++) {
					var next = this.lstHomeroom[i];

					next.TardyTimeDesc = moment(new Date(next.TardyTime)).format("h:mm a");
				}

				//Load Data Filter Lists
				this.lstAcademyDesc = Array.from(new Set(this.lstHomeroom.map((item: any) => item.AcademyDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadHomeroom();
	}

	//Custom Button Methods
	onEditHomeroom() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedHomeroom == undefined) {
			this.errorMessage = "Select a homeroom to edit";
			return;
		}

		var ref = this.dialogService.open(AdminSetupEditHomeroomComponent, {
			header: "Edit Homeroom",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				SelectedHomeroom: this.SelectedHomeroom,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadHomeroom();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedHomeroom = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedHomeroom = null;
	}
	onRowDblClick(Homeroom) {
		this.errorMessage = "";

		this.SelectedHomeroom = Homeroom;
		this.onEditHomeroom();
	}
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadHomeroom();
	}
	////////////////////////////////////////////
}
